import z from 'zod';
import { AllCharLabelSchema, UUIDSchema, UnixTimestampSchema } from '../common/schemas';
import { DBTimestampSchema } from '../common/sql';
import { AppUserRole } from './enums';

/**
 * DB Schemas
 *
 * `app_users.id` is the Cognito access-token `sub`, so a user is created with
 * the id the caller already carries.
 */

export const DBAppUserRoleValueSchema = z.enum(AppUserRole);

export const DBAppUserSchema = z.object({
  id: UUIDSchema,
  displayName: AllCharLabelSchema.nullable(),
  createdAt: DBTimestampSchema,
  updatedAt: DBTimestampSchema.nullable(),
});

export const DBAppUserRoleSchema = z.object({
  userId: UUIDSchema,
  role: DBAppUserRoleValueSchema,
  createdAt: DBTimestampSchema,
});

/**
 * Client Schemas
 */

export const AppUserIdSchema = UUIDSchema.openapi({
  description: 'The Cognito access-token sub of the user',
});

export const AppUserRoleValueSchema = z.enum(AppUserRole).openapi({
  description: 'A quiz-platform role, one per Cognito group the user is in',
  example: AppUserRole.Teacher,
});

export const AppUserSchema = z.object({
  id: AppUserIdSchema,
  displayName: AllCharLabelSchema.nullable(),
  createdAt: UnixTimestampSchema,
  updatedAt: UnixTimestampSchema.nullable(),
});

export const AppUserRoleSchema = z.object({
  userId: AppUserIdSchema,
  role: AppUserRoleValueSchema,
  createdAt: UnixTimestampSchema,
});

/** A user with every role they hold, in no particular order. */
export const AppUserWithRolesSchema = AppUserSchema.extend({
  roles: z.array(AppUserRoleValueSchema),
});
